import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCEFGiuLuUJVDooKAeYUkP9uDA_nbJThwQ',
  appId: '1:671104741351:web:d8f61dc46ded3216d09742',
  messagingSenderId: '671104741351',
  projectId: 'toprayer-7b07d',
  authDomain: 'toprayer-7b07d.firebaseapp.com',
  storageBucket: 'toprayer-7b07d.firebasestorage.app',
  measurementId: 'G-D1FX4G5BND',
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();
const storage = firebase.storage();
let analytics = null;

if (typeof window !== 'undefined' && typeof firebase.analytics === 'function') {
  try {
    analytics = firebase.analytics();
  } catch (e) {
    // Analytics may be blocked by ad blockers or unsupported in some environments
  }
}

export { db, storage, analytics };
export default firebase;